import { useState, useEffect } from "react";
import useSponsors from "../hooks/useSponsors";
import { MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import SponsorLogo from "./SponsorLogo";

const WIDE_BREAKPOINT = 786;

function ImgSlider() {
    const { data: sponsors } = useSponsors();

    const [rolling, setRolling] = useState(true);
    const [currentMidImage, setCurrentMidImage] = useState(0);
    const [imagesSlideCount, setImagesSlideCount] = useState(() =>
        typeof window !== "undefined" && window.innerWidth > WIDE_BREAKPOINT ? 2 : 0
    );

    const data = sponsors || [];

    useEffect(() => {
        const updateSlideCount = () => {
            setImagesSlideCount(window.innerWidth > WIDE_BREAKPOINT ? 2 : 0);
        };
        updateSlideCount();
        window.addEventListener("resize", updateSlideCount);
        return () => window.removeEventListener("resize", updateSlideCount);
    }, []);

    function adjustOffset(num, manual) {
        if (manual) {
            setRolling(false);
        }
        const newIndex =
            currentMidImage + num >= 0
                ? (currentMidImage + num) % data.length
                : data.length - Math.abs(currentMidImage + num);
        setCurrentMidImage(newIndex);
    }

    function getIndices() {
        const indices = [];
        for (let offset = -imagesSlideCount; offset <= imagesSlideCount; offset++) {
            const wrapped =
                ((currentMidImage + offset) % data.length + data.length) % data.length;
            indices.push(wrapped);
        }
        return indices;
    }

    useEffect(() => {
        if (!rolling || data.length === 0) return;
        const interval = setInterval(() => {
            adjustOffset(1, false);
        }, 3000);
        return () => clearInterval(interval);
    });

    if (data.length === 0) return null;

    const isCompact = imagesSlideCount === 0;

    return (
        <div className="relative w-full z-50 mt-4 px-1 sm:px-0">
            <div className="w-full flex flex-row items-center justify-center gap-1 sm:gap-2">
                <button
                    type="button"
                    className="shrink-0 z-50 py-2 px-0.5 sm:px-2 cursor-pointer flex items-center select-none"
                    onClick={() => adjustOffset(-1, true)}
                    aria-label="Vorheriger Sponsor"
                >
                    <MdOutlineKeyboardArrowLeft className="text-golden text-5xl sm:text-6xl" />
                </button>

                <div
                    className={`flex-1 min-w-0 min-h-0 flex flex-row items-center justify-center ${
                        isCompact ? "h-56" : "h-40 md:h-44 lg:h-48"
                    }`}
                >
                    {getIndices().map((index) => (
                        <div
                            className={`select-none p-1 min-w-0 h-full ${
                                isCompact ? "w-full max-w-sm" : "flex-1"
                            }`}
                            key={`${index}-${data[index]?.img}`}
                        >
                            <div className="bg-blue-medium w-full h-full cursor-pointer overflow-hidden">
                                <SponsorLogo
                                    src={data[index].img}
                                    minScale={isCompact ? 0.9 : undefined}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    type="button"
                    className="shrink-0 z-50 py-2 px-0.5 sm:px-2 cursor-pointer flex items-center select-none"
                    onClick={() => adjustOffset(1, true)}
                    aria-label="Nächster Sponsor"
                >
                    <MdOutlineKeyboardArrowRight className="text-golden text-5xl sm:text-6xl" />
                </button>
            </div>
        </div>
    );
}

export default ImgSlider;
